module.exports = __webpack_public_path__ + "img/item19.d4423652.png";